
import { useEffect, useState } from "react";
import { Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import TopNavigation from "./components/TopNavigation";
import AppSidebar from "./components/AppSidebar";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import { useIsMobile } from "./hooks/use-mobile";
import { AuthProvider } from "./lib/AuthContext";
import { SubscriptionProvider } from "./lib/SubscriptionContext";
import Home from "./pages/Home";
import Index from "./pages/Index";
import Login from "./pages/Login";
import ChitPools from "./pages/ChitPools";
import CreateChitPool from "./pages/CreateChitPool";
import EditChitPool from "./pages/EditChitPool";
import ChitPoolDetails from "./pages/ChitPoolDetails";
import Loans from "./pages/Loans";
import CreateLoan from "./pages/CreateLoan";
import LoanDetails from "./pages/LoanDetails";
import Customers from "./pages/Customers";
import NotFound from "./pages/NotFound";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund"; 
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import "./App.css";

function App() {
  const location = useLocation();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("mobile", isMobile);
  }, [isMobile]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const isAuthPage = location.pathname === "/login";
  const isLandingPage = location.pathname === "/";
  const isStaticPage = ["/terms", "/privacy", "/refund", "/subscription-success"].includes(location.pathname);

  return (
    <HelmetProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <div className="grid min-h-screen w-full">
            {!isLandingPage && !isAuthPage && !isStaticPage && <AppSidebar open={sidebarOpen} setOpen={setSidebarOpen} />}
            <div className="flex flex-col">
              {!isLandingPage && !isAuthPage && !isStaticPage && <TopNavigation toggleSidebar={toggleSidebar} />}
              <main className={`${!isLandingPage && !isAuthPage && !isStaticPage ? "container mx-auto px-4 pt-20 pb-10 lg:pt-24" : ""}`}>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/refund" element={<Refund />} />
                  <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                  <Route element={
                    <ProtectedRoute>
                      <Outlet />
                    </ProtectedRoute>
                  }>
                    <Route path="/home" element={<Home />} />
                    <Route path="/chit-pools" element={<ChitPools />} />
                    <Route path="/chit-pools/new" element={<CreateChitPool />} />
                    <Route path="/chit-pools/:id" element={<ChitPoolDetails />} />
                    <Route path="/chit-pools/:id/edit" element={<EditChitPool />} />
                    <Route path="/loans" element={<Loans />} />
                    <Route path="/loans/new" element={<CreateLoan />} />
                    <Route path="/loans/:id" element={<LoanDetails />} />
                    <Route path="/customers" element={<Customers />} />
                  </Route>
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
            </div>
          </div>
          <Toaster />
        </SubscriptionProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
